export const locale = {
    'ORDERSLIST': {
        'TITLE': 'Список заказов',
    },
    'VEHICLE.GROUP.ALL': 'Все',
};
